<template>
  <div class="w-full h-full flex flex-col bg-backgroundColor">
    <div class="w-full h-[240px] md:h-[540px] 2xl:h-[520px]">
      <HomeBanner />
      
    </div>
    <div class="">
      <KhmerForceSecurity />
      <OurMission />
      <WhoWeAre />
      <WhyChooseUs />
      <OurPartner />
    </div>
  </div>
</template>

<script>
import HomeBanner from "@/components/HomePage/HomeBanner.vue";
import KhmerForceSecurity from "@/components/HomePage/KhmerForceSecurity.vue";
import OurMission from "@/components/HomePage/OurMission.vue";
import OurPartner from "@/components/HomePage/OurPartner.vue";
import WhoWeAre from "@/components/HomePage/WhoWeAre.vue";
import WhyChooseUs from "@/components/HomePage/WhyChooseUs.vue";
export default {
  name: "HomePage",
  components: {
    HomeBanner,
    OurMission,
    WhoWeAre,
    WhyChooseUs,
    OurPartner,
    KhmerForceSecurity,
  },
};
</script>
